export class ArgumentValidator  {

    public static notNullOrEmpty(object: any, argumentName: string, message?: string) {

        if (!argumentName) {

            throw new Error(`Argument: "argumentName" can't be null or empty`);
        }

        if (!object) {

            throw new Error(message || `Argument: "${argumentName}" can't be null or empty`);
        }
    }

    public static notLessThanZero(num: number, argumentName: string, message?: string) {

        if (!argumentName) {

            throw new Error(`Argument: "argumentName" can't be null or empty`);
        }

        if (num < 0) {

            throw new Error(message || `Argument: "${argumentName}" can't be less than zero`);
        }
    }

    public static notLessThanOrEqualToZero(num: number, argumentName: string, message?: string) {

        if (!argumentName) {

            throw new Error(`Argument: "argumentName" can't be null or empty`);
        }

        if (num <= 0) {

            throw new Error(message || `Argument: "${argumentName}" can't be less than zero`);
        }
    }
}
